
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inverno",
      function () {
        return require("private-next-pages/inverno.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inverno"])
      });
    }
  